import {AuthorizationFetcher, utils} from '@wallaby-ui/core';

/** @deprecated */
const DashboardFetcher = {
  get(requestUrl) {
    return AuthorizationFetcher.interceptedFetch(
      requestUrl,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },
};

export default DashboardFetcher;
